import styled from '@emotion/styled'

interface ITypeBadgeWrapperProps {
    small: boolean
    bgColor: string
}

export const TypeBadgeWrapper = styled.span<ITypeBadgeWrapperProps>`
  border-radius: 2px;
  line-height: ${({small}) => (small ? '14px' : '16px')};
  font-size: ${({small}) => (small ? '10px' : '12px')};
  padding: 3px 5px;
  margin: 0 10px 0 0;
  width: fit-content;
  color: white;
  text-align: center;
  background-color: ${({bgColor}) => bgColor};
  white-space: nowrap;
`
